<template>
  <b-container id="chatbot" class="mb-5">
    <h2>{{ msg }}</h2>
    <b-row class="justify-content-md-center">
      <b-col col lg="">
        <img alt="covid banner" src="../assets/chatbot.png">
      </b-col>
      <b-col md="9" class="text-left mt-3">
      <p>
        The Chatbot gets the input text from the OpenCV feature detection which is build using various contour analysis and feature extraction.
        The hand feature detection is taken through the webcam which is then processed into a binary image upon which contour analysis is done and to optimize such actions using OpenCV functions. 
      </p>
      <p>
        The extracted feature is then passed into the neural network algorithms which pass the feature through various layers and predict a single output which is then mapped to a text file. 
      </p>
      <p>
      One of the most important objectives of our model is to decrease the communication gap between hearing-impaired people and normal people and use this technology to its best in order to smooth integration of these differently-abled people in our society.
      </p>
      </b-col>
    </b-row>
    <!-- <b-row class="justify-content-md-center">
      <b-col>
        <h2>DATA VISUALISATIONS</h2>
        <iframe src="https://ourworldindata.org/grapher/covid-19-testing-policy?stackMode=absolute&country=&region=World" loading="lazy" style="width: 100%; height: 600px; border: 0px none;"></iframe>
      </b-col>
    </b-row> -->
  </b-container>
</template>

<script>
export default {
  name: 'Software achitecture',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
a {
  color: #42b983;
}
p {
  font-weight: 600;
}
</style>
